import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Gift, X } from "lucide-react";
import { track } from "../utils/track";

/**
 * Tarjeta pequeña y descartable tras una extracción correcta (2-10-2026): es el momento en que el usuario está más
 * contento. Si la descarta, no vuelve a salir en 14 días.
 */
const KEY = "ws_ref_nudge_until";
const hidden = () => {
  try {
    return Number(localStorage.getItem(KEY) || 0) > Date.now();
  } catch {
    return false;
  }
};

export default function ReferralNudge() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(() => !hidden());
  if (!open) return null;
  const close = () => {
    try {
      localStorage.setItem(KEY, String(Date.now() + 14 * 86400000));
    } catch {
      /* sin almacenamiento: reaparecerá en la siguiente extracción */
    }
    setOpen(false);
  };
  return (
    <div data-testid="referral-nudge" className="mt-6 flex items-start gap-3 rounded-2xl border border-primary-100 bg-primary-50/60 p-4">
      <div className="p-2 bg-primary-100 text-primary-600 rounded-lg shrink-0">
        <Gift className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-gray-900">{t("referrals.card_title")}</p>
        <p className="text-sm text-gray-600">{t("referrals.card_text", { pages: 20 })}</p>
        <Link
          to="/referrals"
          onClick={() => track("referral_nudge_click")}
          className="inline-block mt-2 rounded-lg bg-primary-600 hover:bg-primary-700 text-white text-sm font-semibold px-3 py-1.5"
        >
          {t("referrals.card_cta")}
        </Link>
      </div>
      <button onClick={close} aria-label={t("referrals.card_close")} className="text-gray-400 hover:text-gray-600 p-1">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
